import { useRoute } from "wouter";
import { CategoryInfo } from "../components/CategoryInfo";
import { AnimatePresence } from "framer-motion";

export function CategoryInfoScreen() {
	let [match, params] = useRoute("/tech-radar/category/:slug");

	return (
		<AnimatePresence>
			{match ? (
				<CategoryInfo key="category-info" activeCategory={params?.slug} />
			) : null}
		</AnimatePresence>
	);
}
